import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { ApiEndpoints } from '@app/utils/enums/api-endpoints';
import { environment } from '@env/environment';
import {
  CommunicationPreferenceTableData,
  CommunicationPreferenceRawData,
} from '@app/utils/types/communication-preferences.type';

@Injectable({
  providedIn: 'root',
})
export class CommunicationPreferencesService {
  private readonly baseUrl = environment.apiBaseUrl;
  private readonly httpClient = inject(HttpClient);

  public getPreferencesTableData(): Observable<CommunicationPreferenceTableData[]> {
    return this.httpClient
      .get<{
        data: CommunicationPreferenceRawData;
      }>(this.baseUrl + ApiEndpoints.GET_COMMUNICATION_PREFERENCE)
      .pipe(
        map(({ data }: { data: CommunicationPreferenceRawData }) =>
          CommunicationPreferencesService.CommunicationPreferenceTableDataFactory(data),
        ),
      );
  }

  public updatePreferences(
    preference: CommunicationPreferenceRawData,
  ): Observable<HttpResponse<object>> {
    let params = new HttpParams();

    Object.entries(preference).forEach(([key, value]: [string, boolean]) => {
      params = params.set(key, value);
    });

    return this.httpClient.put(
      this.baseUrl + ApiEndpoints.PUT_COMMUNICATION_PREFERENCE,
      {},
      { params, observe: 'response' },
    );
  }

  public subscribe(): void {
    // TODO WHEN US 2.5 COMES INTO PLAY
  }

  private static CommunicationPreferenceTableDataFactory(
    rawData: CommunicationPreferenceRawData,
  ): CommunicationPreferenceTableData[] {
    const isAllMail =
      rawData.communicationPreferenceEmail &&
      rawData.orderUpdateEmail &&
      rawData.promotionEmail &&
      rawData.shipmentUpdateEmail;

    const isAllSms =
      rawData.communicationPreferenceSms &&
      rawData.orderUpdateSms &&
      rawData.promotionSms &&
      rawData.shipmentUpdateSms;

    const isAllPushNotification =
      rawData.communicationPreferencePush &&
      rawData.orderUpdatePush &&
      rawData.promotionPush &&
      rawData.shipmentUpdatePush;

    const prefix = 'user-profile.notifications.table.type';

    return [
      {
        title: `${prefix}.allNotifications.title`,
        email: isAllMail,
        sms: isAllSms,
        pushNotification: isAllPushNotification,
      },
      {
        title: `${prefix}.orderUpdates.title`,
        email: rawData.orderUpdateEmail,
        sms: rawData.orderUpdateSms,
        pushNotification: rawData.orderUpdatePush,
      },
      {
        title: `${prefix}.shipmentUpdates.title`,
        email: rawData.shipmentUpdateEmail,
        sms: rawData.shipmentUpdateSms,
        pushNotification: rawData.shipmentUpdatePush,
      },
      {
        title: `${prefix}.promotions.title`,
        email: rawData.shipmentUpdateEmail,
        sms: rawData.shipmentUpdateSms,
        pushNotification: rawData.shipmentUpdatePush,
      },
      {
        title: `${prefix}.communicationPreferences.title`,
        email: rawData.communicationPreferenceEmail,
        sms: rawData.communicationPreferenceSms,
        pushNotification: rawData.communicationPreferencePush,
      },
    ];
  }
}
